import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "@idw-types/state/application-state";
import { refreshAxnCacheReduxRequest } from "@redux-requests/axn-cache";
import { ButtonWithSpinner } from "../../common/button-with-spinner/button-with-spinner";
import { ContentPageHeader } from "../../common/content-page-header/content-page-header";
import { LoadingIndicator } from "../../common/loading-indicator/loading-indicator";
import { RefreshResultsContainer } from "../refresh-results-container/refresh-results-container";
import { CardContainer } from "../../common/card-container/card-container";
import { resources } from "@constants/hardcoded-strings";
import { ContentPageBody } from "../../common/content-page-body/content-page-body";
import { ButtonTypes } from "@enums/button-types";

export const AxnCacheContainer = () => {
    const dispatch = useDispatch();
    const { isRefreshing, lastRefreshDate, refreshResults } = useSelector((state: ApplicationState) => ({
        isRefreshing: state.axnCache.isRefreshing,
        lastRefreshDate: state.axnCache.lastRefreshDate,
        refreshResults: state.axnCache.refreshResults
    }));

    const onClickRefreshCache = () => {
        refreshAxnCacheReduxRequest(dispatch)();
    };

    const headerButton = useMemo(() => {
        return (
            <ButtonWithSpinner
                id="axn-refresh-cache-button"
                onClick={onClickRefreshCache}
                disabled={isRefreshing}
                variant="primary"
                label={resources.common.buttons.refresh.label}
                type={ButtonTypes.BUTTON}
            />
        );
    }, [isRefreshing]);

    return (
        <CardContainer>
            <ContentPageHeader title={resources.pages.axnCache.header} headerButton={headerButton} />
            <ContentPageBody isMaxWidth={true}>
                {!isRefreshing && refreshResults && (
                    <RefreshResultsContainer lastRefreshDate={lastRefreshDate} refreshResults={refreshResults} />
                )}
                {isRefreshing && (
                    <LoadingIndicator title={resources.pages.axnCache.loadingIndicatorText} />
                )}
            </ContentPageBody>
        </CardContainer>
    );
};